import { MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../state/state';
import { Box, Button, Icon } from '@ace-clublabs/shared-component-library';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../../utils/constants';
import { useState } from 'react';
import { hasPITOrPendingChange } from '../../../utils/ruleHelper';
import { PITWarningModal } from '../../PITWarningModal/PITWarningModal';
import { UtagHelper } from '../../../utils/UtagHelper';

export const UpgradeBenefitsCTA = () => {
  const history = useHistory();
  const [membershipDetails] = useGlobalState('memberDetails');
  const [showPITWarningModal, setShowPITWarningModal] = useState(false);
  const currentLevel = membershipDetails?.benefitLevels?.existingLevel;
  const hasPITPendingChange = hasPITOrPendingChange(membershipDetails);
  const label =
    currentLevel == MembershipLevel.CLASSIC || currentLevel == MembershipLevel.PLUS
      ? 'Upgrade benefits'
      : 'Manage membership';
  const nextPage =
    currentLevel == MembershipLevel.CLASSIC || currentLevel == MembershipLevel.PLUS
      ? Pages.ChangeBenefitLevelPage
      : Pages.ManageMembershipPage;

  const onClick = () => {
    if (hasPITPendingChange) {
      setShowPITWarningModal(true);
    } else {
      if (nextPage === Pages.ChangeBenefitLevelPage) {
        history.push(nextPage);
      } else {
        history.push({
          pathname: Pages.ManageMembershipPage,
          search: UtagHelper.getIntcmpQueryParam(Pages.HomePage, 'quickaction_', Pages.ManageMembershipPage),
        });
      }
    }
  };
  return (
    <>
      <Box>
        <Button
          variant="tile"
          label={label}
          startIcon={<Icon iconName="award-duotone" />}
          id="UpgradeBenefitsCTA"
          onClick={onClick}
          sx={{ background: 'white', whiteSpace: 'nowrap' }}
        />
      </Box>
      <PITWarningModal
        visible={showPITWarningModal}
        onClose={() => {
          setShowPITWarningModal(false);
        }}
      />
    </>
  );
};
